<template>
  <v-dialog
      class="image-dialog"
      ref="dialog"
      v-model="open"

  >
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-img class="zoom"
               v-touch="touchHandler"
               contain
               :src="image_list[image_index]"
        ></v-img>

      </v-card-text>

      <v-card-actions>

        <!--        <v-spacer></v-spacer>-->
        <!--        <v-btn-->
        <!--            color="primary"-->
        <!--            text-->
        <!--            @click="open = false"-->
        <!--        >-->
        <!--          Close-->
        <!--        </v-btn>-->
        <!--        <v-row>-->
        <v-col v-for="(image,index) in image_list"
               @click="image_index=index"
               class="col-1">
          <v-img class="thumbnail" :class="{'hi-light':index==image_index}" :src="image"></v-img>
        </v-col>
        <!--        </v-row>-->
      </v-card-actions>
      <v-btn bottom class="dialog-close-button" color="primary" fab fixed right
             @click="open = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.image-dialog {
  //height: calc(100vh - 100px);
  //width: calc(100vw - 100px);
}

.thumbnail {
  max-height: 80px;
  opacity: 0.5;
  //border:2px solid white;
}

.hi-light {
  opacity: 1 !important;
  //border:2px solid blue !important;
}

.zoom {
  max-height: calc(100vh - 240px);

}

.dialog-close-button {
  right: 40px;
  bottom: 70px;
}
</style>
<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {}
})
export default class ImageGallery extends Vue {

  open: boolean = false
  image_list = {}
  image_index = 0


  created() {
    this.$root.$on('openImageGallery', this.onOpen)
  }

  onOpen({imageList, imageIndex = 0}) {
    if (this.open) return
    this.image_list = imageList
    this.image_index = imageIndex
    this.open = true
    // console.log('openImageGallery imageList', imageList)
    // console.log('openImageGallery imageIndex', imageIndex)
  }

  touchHandler(event) {
    console.log('touchHandler', event)
    // v-touch.swipe.left="image_index = (image_index+1)%image_list.length"
    // v-touch.swipe.right="image_index = (image_index-1)%image_list.length"

  }

};

</script>
